// extracted by mini-css-extract-plugin
module.exports = {"basic-item-child-top-tag-text":"basic-item-child-top-tag-text___3p0uo","basic-item-child-left-tag-text":"basic-item-child-left-tag-text___1612q"};